import UserProfileAdd2 from 'blaze-ui/icons/20/UserProfileAdd2'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { ConnectedIntegration } from 'components/Onboarding/Integration/ConnectedIntegration'
import { ProviderToConnectText } from 'screens/blaze/Home/VirtualMarketerHome/Performance/ConnectIntegrationRow'
import { Button } from 'blaze-ui/Button'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { isSocialMediaIntegration } from 'components/TacticIntegrationList/utils'
import Styles from './ChannelIntegrationButton.module.scss'
import { ConnectedIntegrationsButton } from './ConnectedIntegrationsButton'
import client from 'api/client'

interface ChannelIntegrationButtonProps {
  integrations?: ExternalIntegration[]
  isHovered: boolean
  provider?: ExternalIntegrationEnum
  isDisabled?: boolean
  showDisabledLabel?: boolean
}

export const ChannelIntegrationButton = ({
  integrations = [],
  isHovered,
  provider,
  isDisabled,
  showDisabledLabel = false,
}: ChannelIntegrationButtonProps) => {
  const { connect } = useConnectAccountPopup()
  const multipleAccountsEnabled = useFlipperFlag('multiple_accounts')
  const integration = integrations[0] || null
  const hasIntegrations = integrations.length > 0

  if (!provider) {
    if (!isHovered) return null

    return (
      <Button frontIcon={UserProfileAdd2} variant="secondary" size="md" isDisabled>
        Coming Soon
      </Button>
    )
  }

  if (isHovered && (!hasIntegrations || (hasIntegrations && isDisabled))) {
    return (
      <InitiateOauthTrigger provider={provider} popUp onInitiatedOauth={connect}>
        <Button
          frontIcon={UserProfileAdd2}
          variant="secondary"
          size="md"
          isDisabled={isDisabled}
          aria-label={`Connect ${ProviderToConnectText[provider]}`}
        >
          {isDisabled && showDisabledLabel
            ? 'To enable this channel, remove another first'
            : `Connect ${ProviderToConnectText[provider]}`}
        </Button>
      </InitiateOauthTrigger>
    )
  }

  const showMultipleAccounts = multipleAccountsEnabled && isSocialMediaIntegration(provider)

  if (hasIntegrations && !isDisabled) {
    return (
      <div className={Styles.connectedButtonContainer}>
        {showMultipleAccounts && isHovered && (
          <InitiateOauthTrigger
            provider={provider}
            popUp
            onInitiatedOauth={(popup?: Window) => {
              connect(popup, {
                isAdditionalAccount: true,
                onConnect: () => {
                  client.trackEvent('Event::ExtraAccountAddedOnTrial', { variant: 'onboarding' })
                },
              })
            }}
          >
            <Button frontIcon={UserProfileAdd2} variant="secondary" size="md" isDisabled={isDisabled}>
              Add Extra Account for $10/month
            </Button>
          </InitiateOauthTrigger>
        )}
        {showMultipleAccounts ? (
          <ConnectedIntegrationsButton integrations={integrations} />
        ) : (
          <ConnectedIntegration integration={integration} showDisconnectButton={false} />
        )}
      </div>
    )
  }

  return null
}
